const url = "https://yk2emj2ytdtvlonim7kottyh7e0xjyhr.lambda-url.ap-northeast-2.on.aws/";

// 대기열 등록
export const storeQueue = async ({
  shop,
  customerId,
  cartId,
}: {
  shop: string;
  customerId: string;
  cartId: string;
}) => {
  try {
    const response = await fetch(url, {
      method: "POST",
      body: JSON.stringify({ store: shop, customerId, cartId }),
    }).then((res) => res);

    if (response.status === 200) {
      return response.json();
    }
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    throw new Error(message);
  }
};
